import './HealthBar.css';
import emptyHeartImg from './content/icon_empty_heart.png';
import heartImg from './content/icon_heart.png';

/** Figma hearts (130:21442) — right-aligned with finish flag (922 + 127). */
const HEART_SLOT_LEFT = 648.2306;
const HEART_SLOT_STEP = 83.7539;
const HEART_SLOTS = [
  { left: HEART_SLOT_LEFT, top: 304 },
  { left: HEART_SLOT_LEFT + HEART_SLOT_STEP, top: 304 },
  { left: HEART_SLOT_LEFT + HEART_SLOT_STEP * 2, top: 304 },
  { left: HEART_SLOT_LEFT + HEART_SLOT_STEP * 3, top: 304 },
  { left: HEART_SLOT_LEFT + HEART_SLOT_STEP * 4, top: 304 },
] as const;

const HEART_WIDTH = 65.7538;
const HEART_HEIGHT = 58.2608;

export type HealthBarProps = {
  /** Current health (filled hearts). */
  value?: number;
  /** Max health (total hearts). Capped by layout slots. */
  max?: number;
};

export function HealthBar({
  value = 4,
  max = HEART_SLOTS.length,
}: HealthBarProps) {
  const slotCount = Math.min(Math.max(max, 0), HEART_SLOTS.length);
  const filled = Math.max(0, Math.min(value, slotCount));

  return (
    <>
      {HEART_SLOTS.slice(0, slotCount).map((slot, index) => {
        const isFilled = index < filled;
        return (
          <div
            key={index}
            className="health-bar__slot"
            style={{
              left: slot.left,
              top: slot.top,
              width: HEART_WIDTH,
              height: HEART_HEIGHT,
            }}
            role={index === 0 ? 'meter' : undefined}
            aria-label={index === 0 ? 'Здоровье' : undefined}
            aria-valuemin={index === 0 ? 0 : undefined}
            aria-valuemax={index === 0 ? slotCount : undefined}
            aria-valuenow={index === 0 ? filled : undefined}
            aria-hidden={index === 0 ? undefined : true}
          >
            <div className="health-bar__heart-wrap">
              <img
                className="health-bar__heart"
                src={isFilled ? heartImg : emptyHeartImg}
                alt=""
                draggable={false}
              />
            </div>
          </div>
        );
      })}
    </>
  );
}
